/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoContainer = styled.div`
  padding: ${token('space.250', '20px')} 0 ${token('space.050', '4px')}
    ${token('space.050', '4px')};
`;

export const SpinnerContainer = styled.div`
  padding-left: ${token('space.050', '4px')};
  padding-right: ${token('space.100', '8px')};
`;

export const ErrorContainer = styled.div`
  padding-top: ${token('space.250', '20px')};
`;

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${token('space.050', '4px')};
  padding-right: ${token('space.050', '4px')};
`;

export const ErrorMessage = styled.div`
  color: ${token('color.text', colors.N800)};
`;

export const AdditionalTransitions = styled.div`
  color: ${token('color.text.subtlest', colors.N300)};
  font-size: 0.9em;
`;
